export default __webpack_public_path__ + "static/media/File_No_6.4f89a0f8.pdf";